import React from 'react';
import styled from 'styled-components';
import { navigateToEntity } from '../../utils/linkParser';

const LinkButton = styled.button`
  background: none;
  border: none;
  color: var(--link-color);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  display: inline;

  &:hover {
    filter: brightness(1.12);
    text-decoration: none;
  }

  &:focus {
    outline: 2px solid var(--link-color);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

const ClickableLink = ({ entityType, entityId, content }) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (entityType && entityId) {
            navigateToEntity(entityType, entityId);
        }
    };

    const getDisplayText = () => {
        if (!entityType) {
            return content;
        }
        return content;
    };

    const getTitle = () => {
        if (!entityType || !entityId) {
            return `Go to ${content}`;
        }
        return `Go to ${entityType} #${entityId}`;
    };

    return (
        <LinkButton
            type="button"
            className="chat-message-link"
            onClick={ handleClick }
            title={ getTitle() }
            aria-label={ getTitle() }
        >
            { getDisplayText() }
        </LinkButton>
    );
};

export default ClickableLink;
